// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__uaxYe","fileBtn":"File_fileBtn__3RmlU","closeBtn":"File_closeBtn__11AkT","fileSelected":"File_fileSelected__2RAwj","disabled":"File_disabled__3qMny"};